import React from 'react'

function BA_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp p-5'>
                    <div className='mt-5'>
                        <h1 className='pt-5 display-6 review_component_text'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>10,000+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Vedant Vishal Trivedi</h5>
                    <h6 class="font-weight-bold my-2">SNJB'S Late Sau K.B.Jain College of Engineering </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The session was worth of money. It was right decision to register for business analytics I learnt many concepts and sharpen my skills.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Sneha Sharma</h5>
                    <h6 class="font-weight-bold my-2">Satyawati College Delhi University, BA</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I got to learn so mch from this internship. Business analytics is a total new domain for me and internselite made it very easier for me to learn and grow in this field. Teachers are also very friendly and their way of teaching is also nice.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Koustav Mandal</h5>
                    <h6 class="font-weight-bold my-2">Institute of Engineering and Management, IT</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>This program has empowered me with valuable skills, ethical awareness, and practical experience in the field of Data Science and Business Analytics. I am grateful for this opportunity and excited to apply my knowledge in future endeavors.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Ritul Mishra</h5>
                    <h6 class="font-weight-bold my-2">SKN Sinhgad Institute of Technology and Science Lonavala, IT</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Overall the session was very interactive and awesome. Practical experience is one of the primary benefits of this internship and training. You get to apply what you've learned in a real-world setting, gaining valuable skills and knowledge.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Hitesh Kumar</h5>
                    <h6 class="font-weight-bold my-2">NIT, Kurukshetra and Computer Applications</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>This program provided a valuable learning experience, encompassing various projects and equipping me with skills in Python, data analytics, Tableau, and machine learning. Special thanks to Instructors Dhawani Maam and Kiran Maam, and to Internselite for this opportunity.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Harshvardhan Ashok Jadhav</h5>
                    <h6 class="font-weight-bold my-2">Indian Institute of Management Bodhgaya, IPM</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was very good experience for me. I really enjoyed my internship and training. I got to learns many things from the mentor which I was not aware about. I found my interest in business analytics.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default BA_Review_Program_Page
